var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousekeeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_676_1040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9241 124C40.0527 124 34.463 118.41 34.463 111.539C34.463 111.352 34.4668 111.166 34.4754 110.981H12.2064C7.12971 110.981 3 106.851 3 101.774C3 98.5181 4.74054 95.6206 7.33972 93.9823V63.7825C4.74054 62.1443 3 59.2468 3 55.9904C3 52.7341 4.74054 49.8365 7.33972 48.1983V17.9985C4.74054 16.3603 3 13.4627 3 10.2064C3 5.12971 7.12971 1 12.2064 1H81.6419C86.7186 1 90.8483 5.12971 90.8483 10.2064C90.8483 13.4627 89.1077 16.3603 86.5086 17.9985V48.1983C89.1077 49.8365 90.8483 52.7341 90.8483 55.9904C90.8483 59.2468 89.1077 62.1443 86.5086 63.7825V73.0393H113.539C120.41 73.0393 126 78.629 126 85.5005C126 92.372 120.41 97.9617 113.539 97.9617H112.968C112.977 98.1469 112.981 98.3329 112.981 98.5197C112.981 98.8986 112.964 99.2745 112.93 99.648C117.985 101.237 121.66 105.967 121.66 111.539C121.66 118.41 116.071 124 109.199 124H46.9241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.048 85.5007C120.048 81.9057 117.133 78.9911 113.538 78.9911H74.481L46.9238 105.029C43.3287 105.029 40.4142 107.944 40.4142 111.539C40.4142 115.134 43.3287 118.049 46.9238 118.049H109.199C112.794 118.049 115.708 115.134 115.708 111.539C115.708 107.944 112.794 105.029 109.199 105.029H100.519C104.114 105.029 107.029 102.115 107.029 98.5198C107.029 94.9248 104.114 92.0102 100.519 92.0102H113.538C117.133 92.0102 120.048 89.0957 120.048 85.5007Z",
    fill: "#002E43",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.291 23.2257V88.7554C13.291 90.5535 14.7477 92.0102 16.5458 92.0102H77.3018C79.0999 92.0102 80.5566 90.5535 80.5566 88.7554V23.2257C80.5566 21.4276 79.0999 19.9709 77.3018 19.9709H16.5458C14.7477 19.9709 13.291 21.4276 13.291 23.2257Z",
    fill: "#00A1FA",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5566 10.2065H13.291V23.2257H80.5566V10.2065Z",
    fill: "#DCF2FF",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5566 88.7554H13.291V101.775H80.5566V88.7554Z",
    fill: "#DCF2FF",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6415 59.2454H12.2061C10.408 59.2454 8.95129 57.7887 8.95129 55.9906C8.95129 54.1925 10.408 52.7358 12.2061 52.7358H81.6415C83.4396 52.7358 84.8963 54.1925 84.8963 55.9906C84.8963 57.7887 83.4396 59.2454 81.6415 59.2454Z",
    fill: "#00A1FA",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6415 13.4614H12.2061C10.408 13.4614 8.95129 12.0047 8.95129 10.2066C8.95129 8.40848 10.408 6.95178 12.2061 6.95178H81.6415C83.4396 6.95178 84.8963 8.40848 84.8963 10.2066C84.8963 12.0047 83.4396 13.4614 81.6415 13.4614Z",
    fill: "#00A1FA",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6415 105.029H12.2061C10.408 105.029 8.95129 103.573 8.95129 101.775C8.95129 99.9765 10.408 98.5198 12.2061 98.5198H81.6415C83.4396 98.5198 84.8963 99.9765 84.8963 101.775C84.8963 103.573 83.4396 105.029 81.6415 105.029Z",
    fill: "#00A1FA",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9239 72.2645C40.3431 72.2645 34.9896 66.911 34.9896 60.3303C34.9896 58.6679 35.4846 55.604 39.7691 48.2199C41.9771 44.4122 44.154 41.2546 44.2454 41.1212C44.8535 40.242 45.8548 39.7166 46.9239 39.7166C47.9929 39.7166 48.9942 40.242 49.6023 41.1212C49.6937 41.2546 51.8706 44.4122 54.0786 48.2199C58.3631 55.604 58.8581 58.6679 58.8581 60.3303C58.8581 66.911 53.5046 72.2645 46.9239 72.2645Z",
    fill: "white",
    stroke: "#002E43",
    strokeWidth: 2.46,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_676_1040",
    x: 0.54,
    y: 0.18,
    width: 131.2,
    height: 131.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.64,
    dy: 3.28
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0196078 0 0 0 0 0.176471 0 0 0 0 0.254902 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_676_1040"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_676_1040",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeeping);
export default __webpack_public_path__ + "static/media/housekeeping.831ae2c19df5b0bd87781d7a6177d99c.svg";
export { ForwardRef as ReactComponent };